import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { BuatTokoResponse } from "../../constants/types";

const createUkm = async (formData: FormData) => {
    const response = await axios.post<BuatTokoResponse>("/api/ukm", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export default function useCreateUkm() {
    const queryClient = useQueryClient();

    return useMutation((formData: FormData) => createUkm(formData), {
        onSuccess: () => {
            queryClient.invalidateQueries(["ukm"]);
        },
    });
}
